<template>
  <EasyDataTable
    :headers="fields"
    :items="creditTransactions"
    :alternating="true"
    :rows-per-page="10000"
    :hide-rows-per-page="true"
  >
    <template #item-transactionDate="item">
      <span v-if="item.transactionDate">
        {{ formatDate(item.transactionDate) }}
      </span>
    </template>
  </EasyDataTable>
</template>

<script>
import moment from 'moment'

export default {
  name: 'transaction-table',
  props: {
    creditTransactions: {}
  },
  computed: {
    fields() {
      return [
        { value: 'fromGroup', text: this.$t('from') },
        { value: 'toGroup', text: this.$t('to') },
        { value: 'amount', text: this.$t('amount') },
        { value: 'transactionDate', text: this.$t('date') }
      ]
    }
  },
  methods: {
    formatDate: function(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
